import CreateAccount from "components/Auth/CreateAcoount"
import React from "react"

function SignupPage() {
	return <CreateAccount />
}

export default SignupPage
